const VEHICLE_BRAND_PARAM = 'wx_vehicle_brand';
const VEHICLE_MODEL_PARAM = 'wx_vehicle_model';
const VEHICLE_TYPE_PARAM = 'wx_vehicle';
const VEHICLE_KTYPE_PARAM = 'wx_vehicle_ktype';

const LEGACY_VEHICLE_BRAND_PARAM = 'filter.p.m.wimexia.vehicle_brand';
const LEGACY_VEHICLE_MODEL_PARAM = 'filter.p.m.wimexia.vehicle_model';
const LEGACY_VEHICLE_TYPE_PARAM = 'filter.p.m.wimexia.vehicle';

const PRODUCT_GROUP_PARAM = 'filter.p.tag';
const CARD_SELECTOR = '[data-wx-catalogue-product-card]';
const GRID_ITEM_SELECTOR = '.product-grid__item';
const STORAGE_KEY = 'wimexia:selectedVehicle';

const fitmentCache = new Map();
const partsCache = new Map();
const vehicleCatalogCache = new Map();

let scheduledFrame = 0;
let applying = false;
let rerunRequested = false;
let lastEmptyModalKey = '';

function normalizeBrand(value) {
  const brand = String(value || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();

  const aliases = {
    MERCEDES: 'MERCEDES-BENZ',
    'MERCEDES BENZ': 'MERCEDES-BENZ',
    VW: 'VOLKSWAGEN',
  };

  return aliases[brand] || brand;
}

function normalizeToken(value) {
  return String(value || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

function valuesFor(params, currentName, legacyName = '') {
  const current = params.getAll(currentName).filter(Boolean);
  if (current.length || !legacyName) return current;
  return params.getAll(legacyName).filter(Boolean);
}

function selectedFilters() {
  const params = new URL(window.location.href).searchParams;

  return {
    vehicleBrands: new Set(
      valuesFor(params, VEHICLE_BRAND_PARAM, LEGACY_VEHICLE_BRAND_PARAM)
        .map(normalizeBrand)
        .filter(Boolean),
    ),
    vehicleModels: new Set(
      valuesFor(params, VEHICLE_MODEL_PARAM, LEGACY_VEHICLE_MODEL_PARAM)
        .map(normalizeToken)
        .filter(Boolean),
    ),
    vehicleTypes: new Set(
      valuesFor(params, VEHICLE_TYPE_PARAM, LEGACY_VEHICLE_TYPE_PARAM)
        .map(normalizeToken)
        .filter(Boolean),
    ),
    vehicleKtypes: new Set(
      params
        .getAll(VEHICLE_KTYPE_PARAM)
        .map((value) => String(value || '').trim())
        .filter(Boolean),
    ),
    productGroups: new Set(
      params
        .getAll(PRODUCT_GROUP_PARAM)
        .filter((value) => value.startsWith('wimexia-cat-'))
        .map(normalizeToken)
        .filter(Boolean),
    ),
  };
}

function hasVehicleSelection(filters) {
  return (
    filters.vehicleBrands.size > 0 ||
    filters.vehicleModels.size > 0 ||
    filters.vehicleTypes.size > 0 ||
    filters.vehicleKtypes.size > 0
  );
}

function splitTokens(value) {
  return String(value || '')
    .split('|')
    .map(normalizeToken)
    .filter(Boolean);
}

function productMatchesGroup(card, productGroups) {
  if (!productGroups.size) return true;

  const productTokens = new Set([
    ...splitTokens(card.dataset.wxProductTags),
    ...splitTokens(card.dataset.wxProductCollections).map((handle) => `wimexia-cat-${handle}`),
  ]);

  for (const group of productGroups) {
    if (productTokens.has(group)) return true;
  }

  return false;
}

function itemForCard(card) {
  return card.closest(GRID_ITEM_SELECTOR) || card;
}

function setVisible(card, visible) {
  const item = itemForCard(card);
  item.toggleAttribute('hidden', !visible);
  item.dataset.wxVehicleFilterHidden = visible ? 'false' : 'true';
}

function normalizeShopifyProductId(value) {
  const match = String(value || '').match(/(\d+)$/);
  return match ? match[1] : '';
}

function statusSlot() {
  return document.querySelector('[data-wx-vehicle-filter-result-status]');
}

function setStatus(message, state = 'selection') {
  const slot = statusSlot();
  if (!(slot instanceof HTMLElement)) return;

  if (!message) {
    slot.hidden = true;
    slot.textContent = '';
    slot.removeAttribute('data-state');
    return;
  }

  slot.textContent = message;
  slot.dataset.state = state;
  slot.hidden = false;
}

function selectionLabel(filters) {
  const brand = [...filters.vehicleBrands][0] || '';
  const model = [...filters.vehicleModels][0] || '';
  const type = [...filters.vehicleTypes][0] || '';
  return [brand, model, type].filter(Boolean).join(' · ');
}

function rawVehicleSelection() {
  const params = new URL(window.location.href).searchParams;

  const brand = valuesFor(params, VEHICLE_BRAND_PARAM, LEGACY_VEHICLE_BRAND_PARAM)[0] || '';
  const model = valuesFor(params, VEHICLE_MODEL_PARAM, LEGACY_VEHICLE_MODEL_PARAM)[0] || '';
  const type = valuesFor(params, VEHICLE_TYPE_PARAM, LEGACY_VEHICLE_TYPE_PARAM)[0] || '';
  const ktype = params.get(VEHICLE_KTYPE_PARAM) || '';

  return { brand, model, type, ktype };
}

function vehicleDisplayLabel() {
  const vehicle = rawVehicleSelection();
  return [vehicle.brand, vehicle.model, vehicle.type].filter(Boolean).join(' · ');
}

function configuredWhatsappUrl() {
  const configuredLink = document.querySelector('.wx-whatsapp-modal__link');
  return configuredLink instanceof HTMLAnchorElement && configuredLink.href
    ? configuredLink.href
    : 'https://wa.me/33670833954';
}

function whatsappUrlWithMessage(message) {
  const baseHref = configuredWhatsappUrl();

  try {
    const url = new URL(baseHref, window.location.origin);
    url.searchParams.set('text', message);
    return url.toString();
  } catch {
    return `https://wa.me/33670833954?text=${encodeURIComponent(message)}`;
  }
}

function buildWhatsappRequestUrl() {
  const vehicle = rawVehicleSelection();
  const vehicleLabel = [vehicle.brand, vehicle.model, vehicle.type].filter(Boolean).join(' · ');
  const ktypeLabel = vehicle.ktype ? ` (KType ${vehicle.ktype})` : '';
  const collectionTitle =
    document.querySelector('[data-wx-collection-hero-title]')?.textContent?.trim() ||
    document.title ||
    'le catalogue';

  const message =
    `Bonjour WIMEXIA, je recherche une pièce pour ${vehicleLabel || 'mon véhicule'}${ktypeLabel}. ` +
    `Je n’ai trouvé aucun produit compatible dans ${collectionTitle}. ` +
    'Pouvez-vous m’aider à trouver la bonne référence ?';

  return whatsappUrlWithMessage(message);
}

function buildSearchWhatsappUrl(query) {
  const message =
    `Bonjour WIMEXIA, je recherche la pièce ou la référence « ${query} ». ` +
    'Je ne trouve aucun résultat dans votre catalogue. Pouvez-vous m’aider à identifier ou trouver cette pièce ?';

  return whatsappUrlWithMessage(message);
}

function whatsappQrUrl(whatsappUrl) {
  return `https://quickchart.io/qr?text=${encodeURIComponent(whatsappUrl)}&size=196&margin=1`;
}


function ensureEmptyVehicleModal() {
  let modal = document.querySelector('[data-wx-vehicle-empty-modal]');
  if (modal instanceof HTMLDialogElement) return modal;

  modal = document.createElement('dialog');
  modal.className = 'wx-vehicle-empty-modal';
  modal.dataset.wxVehicleEmptyModal = '';
  modal.innerHTML = `
    <div class="wx-vehicle-empty-modal__panel">
      <button
        class="wx-vehicle-empty-modal__close"
        type="button"
        aria-label="Fermer"
        data-wx-vehicle-empty-close
      >×</button>

      <div class="wx-vehicle-empty-modal__icon" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none">
          <path d="M6 19.2 8.3 14c.5-1.2 1.7-2 3-2h7.4c1.3 0 2.5.8 3 2l2.3 5.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
          <path d="M5.8 19.2h18.4c1 0 1.8.8 1.8 1.8v2c0 1-.8 1.8-1.8 1.8H5.8C4.8 24.8 4 24 4 23v-2c0-1 .8-1.8 1.8-1.8Z" stroke="currentColor" stroke-width="1.7"/>
          <path d="m21.5 7.5 5 5M26.5 7.5l-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </div>

      <p class="wx-vehicle-empty-modal__eyebrow">Compatibilité véhicule</p>
      <h2>Aucune pièce compatible trouvée</h2>

      <p class="wx-vehicle-empty-modal__text">
        Nous n’avons actuellement aucune référence vérifiée correspondant exactement à ce véhicule dans notre catalogue.
      </p>

      <div class="wx-vehicle-empty-modal__vehicle">
        <span>Votre recherche</span>
        <strong data-wx-vehicle-empty-label></strong>
      </div>

      <p class="wx-vehicle-empty-modal__help">
        WIMEXIA peut rechercher la pièce pour vous. Envoyez-nous directement votre demande sur WhatsApp avec les informations du véhicule déjà préparées.
      </p>

      <div class="wx-vehicle-empty-modal__qr">
        <img
          src=""
          width="196"
          height="196"
          loading="lazy"
          alt="QR code vers la conversation WhatsApp WIMEXIA"
          data-wx-vehicle-empty-qr
        >
      </div>

      <p class="wx-vehicle-empty-modal__qr-hint">
        Scannez le QR code ou ouvrez directement la conversation WhatsApp.
      </p>

      <a
        class="wx-vehicle-empty-modal__whatsapp-link"
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        data-wx-vehicle-empty-whatsapp
      >
        Ouvrir WhatsApp
      </a>

      <button
        class="wx-vehicle-empty-modal__secondary"
        type="button"
        data-wx-vehicle-empty-close
      >
        Continuer ma recherche
      </button>
    </div>
  `;

  modal.addEventListener('click', (event) => {
    if (event.target === modal) modal.close();
  });

  modal.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('[data-wx-vehicle-empty-close]')) modal.close();
  });

  document.body.appendChild(modal);
  return modal;
}

function openEmptyVehicleModal(filters, resolvedKtypes) {
  const label = vehicleDisplayLabel() || selectionLabel(filters) || 'Véhicule sélectionné';
  const key = [
    window.location.pathname,
    label,
    [...resolvedKtypes].sort().join(','),
  ].join('|');

  if (lastEmptyModalKey === key) return;
  lastEmptyModalKey = key;

  const modal = ensureEmptyVehicleModal();
  const eyebrow = modal.querySelector('.wx-vehicle-empty-modal__eyebrow');
  const title = modal.querySelector('h2');
  const text = modal.querySelector('.wx-vehicle-empty-modal__text');
  const searchLabel = modal.querySelector('.wx-vehicle-empty-modal__vehicle span');
  const labelNode = modal.querySelector('[data-wx-vehicle-empty-label]');
  const help = modal.querySelector('.wx-vehicle-empty-modal__help');
  const whatsappLink = modal.querySelector('[data-wx-vehicle-empty-whatsapp]');
  const whatsappQr = modal.querySelector('[data-wx-vehicle-empty-qr]');

  if (eyebrow instanceof HTMLElement) eyebrow.textContent = 'Compatibilité véhicule';
  if (title instanceof HTMLElement) title.textContent = 'Aucune pièce compatible trouvée';
  if (text instanceof HTMLElement) {
    text.textContent =
      'Nous n’avons actuellement aucune référence vérifiée correspondant exactement à ce véhicule dans notre catalogue.';
  }
  if (searchLabel instanceof HTMLElement) searchLabel.textContent = 'Votre recherche';
  if (help instanceof HTMLElement) {
    help.textContent =
      'WIMEXIA peut rechercher la pièce pour vous. Scannez le QR code ou ouvrez WhatsApp avec les informations du véhicule déjà préparées.';
  }

  if (labelNode instanceof HTMLElement) {
    const vehicle = rawVehicleSelection();
    labelNode.textContent = vehicle.ktype ? `${label} · KType ${vehicle.ktype}` : label;
  }

  const whatsappUrl = buildWhatsappRequestUrl();

  if (whatsappLink instanceof HTMLAnchorElement) {
    whatsappLink.href = whatsappUrl;
  }

  if (whatsappQr instanceof HTMLImageElement) {
    whatsappQr.src = whatsappQrUrl(whatsappUrl);
  }

  if (typeof modal.showModal === 'function') {
    modal.showModal();
  } else {
    modal.setAttribute('open', '');
  }
}


function openEmptySearchModal(query) {
  const normalizedQuery = String(query || '').trim();
  if (!normalizedQuery) return;

  const key = `search|${normalizedQuery.toLowerCase()}`;
  if (lastEmptyModalKey === key) return;
  lastEmptyModalKey = key;

  const modal = ensureEmptyVehicleModal();
  const eyebrow = modal.querySelector('.wx-vehicle-empty-modal__eyebrow');
  const title = modal.querySelector('h2');
  const text = modal.querySelector('.wx-vehicle-empty-modal__text');
  const searchLabel = modal.querySelector('.wx-vehicle-empty-modal__vehicle span');
  const labelNode = modal.querySelector('[data-wx-vehicle-empty-label]');
  const help = modal.querySelector('.wx-vehicle-empty-modal__help');
  const whatsappLink = modal.querySelector('[data-wx-vehicle-empty-whatsapp]');
  const whatsappQr = modal.querySelector('[data-wx-vehicle-empty-qr]');

  if (eyebrow instanceof HTMLElement) eyebrow.textContent = 'Recherche catalogue';
  if (title instanceof HTMLElement) title.textContent = 'Aucune pièce trouvée';
  if (text instanceof HTMLElement) {
    text.textContent = 'Aucune référence de notre catalogue ne correspond actuellement à cette recherche.';
  }
  if (searchLabel instanceof HTMLElement) searchLabel.textContent = 'Votre recherche';
  if (labelNode instanceof HTMLElement) labelNode.textContent = normalizedQuery;
  if (help instanceof HTMLElement) {
    help.textContent =
      'WIMEXIA peut rechercher la pièce pour vous. Envoyez-nous votre demande sur WhatsApp, même si vous ne connaissez pas la référence exacte.';
  }
  const whatsappUrl = buildSearchWhatsappUrl(normalizedQuery);

  if (whatsappLink instanceof HTMLAnchorElement) {
    whatsappLink.href = whatsappUrl;
  }

  if (whatsappQr instanceof HTMLImageElement) {
    whatsappQr.src = whatsappQrUrl(whatsappUrl);
  }

  if (typeof modal.showModal === 'function') {
    modal.showModal();
  } else {
    modal.setAttribute('open', '');
  }
}

function checkSearchEmptyState() {
  const marker = document.querySelector('[data-wx-search-empty]');
  if (!(marker instanceof HTMLElement)) return;

  const query = marker.dataset.wxSearchQuery || '';
  openEmptySearchModal(query);
}

function readStoredKtype(filters) {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    const variant = saved?.variant || {};
    const ktype = String(saved?.ktype || variant?.ktype || '').trim();
    if (!ktype) return '';

    const savedBrand = normalizeBrand(saved?.makeName || variant?.makeName || '');
    const savedModel = normalizeToken(saved?.modelName || variant?.modelName || '');
    const savedType = normalizeToken(
      variant?.name ||
      variant?.description ||
      variant?.vehicleName ||
      variant?.typeName ||
      variant?.designation ||
      variant?.label ||
      '',
    );

    if (filters.vehicleBrands.size && !filters.vehicleBrands.has(savedBrand)) return '';
    if (filters.vehicleModels.size && !filters.vehicleModels.has(savedModel)) return '';
    if (filters.vehicleTypes.size && !filters.vehicleTypes.has(savedType)) return '';

    return ktype;
  } catch {
    return '';
  }
}

async function requestJson(url) {
  const response = await fetch(url, { headers: { Accept: 'application/json' } });
  const data = await response.json().catch(() => null);

  if (!response.ok || !data?.success) {
    throw new Error(data?.error || 'Réponse WIMEXIA invalide.');
  }

  return data;
}

async function resolveKtypes(filters) {
  const explicit = new Set(filters.vehicleKtypes);
  const storedKtype = readStoredKtype(filters);
  if (storedKtype) explicit.add(storedKtype);
  if (explicit.size) return explicit;

  if (!filters.vehicleBrands.size || !filters.vehicleModels.size || !filters.vehicleTypes.size) {
    return new Set();
  }

  const ktypes = new Set();

  for (const brand of filters.vehicleBrands) {
    for (const model of filters.vehicleModels) {
      const cacheKey = `${brand}|${model}`;
      let variantsPromise = vehicleCatalogCache.get(cacheKey);

      if (!variantsPromise) {
        const params = new URLSearchParams({ makeName: brand, modelName: model });
        variantsPromise = requestJson(`/apps/wimexia/tecdoc-vehicles?${params.toString()}`)
          .then((data) => (Array.isArray(data.items) ? data.items : []))
          .catch(() => []);
        vehicleCatalogCache.set(cacheKey, variantsPromise);
      }

      const variants = await variantsPromise;

      for (const variant of variants) {
        const label = normalizeToken(
          variant?.label ||
          variant?.typeName ||
          variant?.name ||
          '',
        );

        if (!filters.vehicleTypes.has(label)) continue;

        const ktype = String(variant?.ktype || '').trim();
        if (ktype) ktypes.add(ktype);
      }
    }
  }

  return ktypes;
}

async function compatibleProductsForKtypes(ktypes) {
  const productIds = new Set();
  const handles = new Set();

  await Promise.all(
    [...ktypes].map(async (ktype) => {
      let partsPromise = partsCache.get(ktype);

      if (!partsPromise) {
        const params = new URLSearchParams({ ktype });
        partsPromise = requestJson(`/apps/wimexia/parts?${params.toString()}`)
          .then((data) => (Array.isArray(data.parts) ? data.parts : []));
        partsCache.set(ktype, partsPromise);
      }

      const parts = await partsPromise;

      for (const row of parts) {
        const productId = normalizeShopifyProductId(row?.part?.shopify?.productId);
        const handle = String(row?.part?.shopify?.handle || '').trim();

        if (productId) productIds.add(productId);
        if (handle) handles.add(handle);
      }
    }),
  );

  return { productIds, handles };
}


async function storefrontProductExists(handle) {
  try {
    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: 'application/json' },
      cache: 'force-cache',
    });
    return response.ok;
  } catch {
    return null;
  }
}

async function hasAnyLiveStorefrontProduct(compatibleProducts) {
  const handles = [...compatibleProducts.handles];
  if (!handles.length) {
    return compatibleProducts.productIds.size ? null : false;
  }

  const batchSize = 8;
  let hadUnknown = false;

  for (let index = 0; index < handles.length; index += batchSize) {
    const batch = handles.slice(index, index + batchSize);
    const states = await Promise.all(batch.map(storefrontProductExists));

    if (states.some((state) => state === true)) return true;
    if (states.some((state) => state === null)) hadUnknown = true;
  }

  return hadUnknown ? null : false;
}

function currentCollectionHandle() {
  const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/i);
  return match ? decodeURIComponent(match[1]) : '';
}

async function collectionContainsCompatibleProduct(handle, compatibleProducts) {
  if (!handle || handle === 'all') {
    return hasAnyLiveStorefrontProduct(compatibleProducts);
  }

  const compatibleHandles = compatibleProducts.handles;
  const compatibleIds = compatibleProducts.productIds;

  if (!compatibleHandles.size && !compatibleIds.size) return false;

  const maxPages = 20;

  for (let page = 1; page <= maxPages; page += 1) {
    let response;
    let payload;

    try {
      const url = `/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`;
      response = await fetch(url, {
        headers: { Accept: 'application/json' },
        cache: 'force-cache',
      });
      if (!response.ok) return null;
      payload = await response.json();
    } catch {
      return null;
    }

    const products = Array.isArray(payload?.products) ? payload.products : [];

    for (const product of products) {
      const productHandle = String(product?.handle || '').trim();
      const productId = normalizeShopifyProductId(product?.id);

      if (
        (productHandle && compatibleHandles.has(productHandle)) ||
        (productId && compatibleIds.has(productId))
      ) {
        return true;
      }
    }

    if (products.length < 250) return false;
  }

  return null;
}

async function currentScopeCompatibilityState(compatibleProducts) {
  const handle = currentCollectionHandle();
  if (!handle) return null;
  return collectionContainsCompatibleProduct(handle, compatibleProducts);
}

async function fetchProductVehicles(card) {
  const sku = String(card.dataset.wxProductSku || '').trim();
  if (!sku) return [];

  const productId = String(card.dataset.wxProductId || '').trim();
  const cacheKey = `${productId}|${sku.toLowerCase()}`;

  if (fitmentCache.has(cacheKey)) return fitmentCache.get(cacheKey);

  const params = new URLSearchParams({ sku });
  if (productId) params.set('product_id', productId);

  const request = fetch(`/apps/wimexia/product-fitments?${params.toString()}`, {
    headers: { Accept: 'application/json' },
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      const vehicles = [];

      for (const vehicle of data?.vehicles || []) {
        const rawBrand = String(vehicle?.manufacturerName || '').trim();
        const rawModel = String(vehicle?.modelName || '').trim();
        const rawType = String(vehicle?.typeName || '').trim();
        const ktype = String(vehicle?.ktype || '').trim();

        vehicles.push({
          rawBrand,
          rawModel,
          rawType,
          brand: normalizeBrand(rawBrand),
          model: normalizeToken(rawModel),
          type: normalizeToken(rawType),
          ktype,
        });
      }

      return vehicles;
    })
    .catch(() => []);

  fitmentCache.set(cacheKey, request);
  return request;
}

function vehicleMatchesFilters(vehicle, filters) {
  if (filters.vehicleKtypes.size && !filters.vehicleKtypes.has(vehicle.ktype)) return false;
  if (filters.vehicleBrands.size && !filters.vehicleBrands.has(vehicle.brand)) return false;
  if (filters.vehicleModels.size && !filters.vehicleModels.has(vehicle.model)) return false;
  if (filters.vehicleTypes.size && !filters.vehicleTypes.has(vehicle.type)) return false;
  return true;
}

async function fallbackCardMatch(card, filters) {
  if (!productMatchesGroup(card, filters.productGroups)) return false;

  const vehicles = await fetchProductVehicles(card);
  if (!vehicles.length) return false;

  return vehicles.some((vehicle) => vehicleMatchesFilters(vehicle, filters));
}

function syncCustomControlGroup(inputs, params) {
  const selectedValues = new Set(params.getAll(inputs[0]?.name || '').map(normalizeToken));
  let checkedCount = 0;
  let firstLabel = '';

  for (const input of inputs) {
    input.checked = selectedValues.has(normalizeToken(input.value));
    if (!input.checked) continue;
    checkedCount += 1;
    if (!firstLabel) firstLabel = input.dataset.label || input.value;
  }

  const details = inputs[0]?.closest('details');
  const formComponent = inputs[0]?.closest('facets-form-component');
  const filterStyle = formComponent?.getAttribute('form-style') || formComponent?.dataset.filterStyle || '';
  const status = details?.querySelector('[data-wx-custom-filter-status], [data-wx-vehicle-brand-status]');

  if (status) {
    const showCountBubble = filterStyle !== 'horizontal' ? checkedCount > 0 : checkedCount > 1;
    status.textContent =
      filterStyle === 'horizontal' && checkedCount === 1 ? firstLabel : checkedCount > 0 ? String(checkedCount) : '';
    status.classList.toggle('bubble', showCountBubble);
    status.classList.toggle('facets__bubble', showCountBubble);
  }

  const clearButton = details?.querySelector('[data-wx-custom-filter-clear], [data-wx-vehicle-brand-clear]');
  clearButton?.classList.toggle('facets__clear--active', checkedCount > 0);
}

function syncCustomFilterControls() {
  const params = new URL(window.location.href).searchParams;

  for (const formComponent of document.querySelectorAll('facets-form-component')) {
    const inputs = Array.from(formComponent.querySelectorAll('[data-wx-custom-filter-input]'));
    const inputsByName = new Map();

    for (const input of inputs) {
      if (!(input instanceof HTMLInputElement)) continue;
      if (!inputsByName.has(input.name)) inputsByName.set(input.name, []);
      inputsByName.get(input.name).push(input);
    }

    for (const groupedInputs of inputsByName.values()) {
      syncCustomControlGroup(groupedInputs, params);
    }
  }
}

function addOption(optionMap, rawValue) {
  const label = String(rawValue || '').trim();
  const key = normalizeToken(label);
  if (!key || optionMap.has(key)) return;
  optionMap.set(key, label);
}

function sortedOptions(optionMap) {
  return Array.from(optionMap.entries())
    .map(([key, label]) => ({ key, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'fr', { numeric: true, sensitivity: 'base' }));
}

function makeDynamicFilterOption({ list, paramName, option, index, selectedValues }) {
  const item = document.createElement('li');
  item.dataset.skipNodeUpdate = 'true';
  item.className = 'facets__inputs-list-item';

  const wrapper = document.createElement('div');
  wrapper.className = 'checkbox wx-dynamic-vehicle-filter__option';

  const input = document.createElement('input');
  input.type = 'checkbox';
  input.name = paramName;
  input.value = option.label;
  input.id = `${list.id || 'wx-dynamic-vehicle-filter'}-${index + 1}`;
  input.className = 'checkbox__input';
  input.checked = selectedValues.has(option.key);
  input.dataset.label = option.label;
  input.dataset.wxCustomFilterInput = '';
  input.dataset.wxVehicleDynamicInput = '';
  input.setAttribute('ref', 'facetInputs[]');

  const label = document.createElement('label');
  label.className = 'checkbox__label wx-custom-filter__option-label';
  label.setAttribute('for', input.id);
  label.insertAdjacentHTML(
    'afterbegin',
    '<svg class="icon icon-checkmark" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.64a.5.5 0 0 1 .01.7l-6.77 6.97a.5.5 0 0 1-.72 0L.64 4.98a.5.5 0 1 1 .72-.7l2.87 2.96L10.65.65a.5.5 0 0 1 .7-.01Z" fill="currentColor"/></svg>',
  );

  const text = document.createElement('span');
  text.className = 'checkbox__label-text wx-custom-filter__option-text';

  const value = document.createElement('span');
  value.textContent = option.label;

  text.appendChild(value);
  label.appendChild(text);
  wrapper.append(input, label);
  item.appendChild(wrapper);

  return item;
}

function makeDynamicFilterEmpty(message) {
  const item = document.createElement('li');
  item.className = 'facets__inputs-list-item wx-dynamic-vehicle-filter__empty';
  item.textContent = message;
  return item;
}

async function collectDynamicVehicleOptions(cards, filters) {
  const modelOptions = new Map();
  const typeOptions = new Map();

  await Promise.all(
    cards.map(async (card) => {
      if (!productMatchesGroup(card, filters.productGroups)) return;

      const vehicles = await fetchProductVehicles(card);
      for (const vehicle of vehicles) {
        if (filters.vehicleBrands.size && !filters.vehicleBrands.has(vehicle.brand)) continue;
        addOption(modelOptions, vehicle.rawModel);

        if (filters.vehicleModels.size && !filters.vehicleModels.has(vehicle.model)) continue;
        addOption(typeOptions, vehicle.rawType);
      }
    }),
  );

  for (const model of valuesFor(new URL(window.location.href).searchParams, VEHICLE_MODEL_PARAM, LEGACY_VEHICLE_MODEL_PARAM)) {
    addOption(modelOptions, model);
  }
  for (const type of valuesFor(new URL(window.location.href).searchParams, VEHICLE_TYPE_PARAM, LEGACY_VEHICLE_TYPE_PARAM)) {
    addOption(typeOptions, type);
  }

  return {
    model: sortedOptions(modelOptions),
    type: sortedOptions(typeOptions),
  };
}

async function updateDynamicVehicleFilterOptions(filters, cards) {
  const lists = Array.from(document.querySelectorAll('[data-wx-dynamic-vehicle-options]'));
  if (!lists.length) return;

  const optionSets = await collectDynamicVehicleOptions(cards, filters);
  const params = new URL(window.location.href).searchParams;

  for (const list of lists) {
    const kind = list.dataset.wxDynamicVehicleOptions;
    const paramName = list.dataset.wxDynamicParam || (kind === 'model' ? VEHICLE_MODEL_PARAM : VEHICLE_TYPE_PARAM);
    const options = optionSets[kind] || [];
    const selectedValues = new Set(params.getAll(paramName).map(normalizeToken));
    const stateKey = JSON.stringify([kind, options.map((option) => `${option.key}:${option.label}`), [...selectedValues].sort()]);

    if (list.dataset.stateKey === stateKey) continue;
    list.dataset.stateKey = stateKey;
    list.replaceChildren();

    if (!options.length) {
      list.appendChild(makeDynamicFilterEmpty(kind === 'model' ? 'Aucun modèle disponible' : 'Aucun véhicule disponible'));
      continue;
    }

    options.forEach((option, index) => {
      list.appendChild(makeDynamicFilterOption({ list, paramName, option, index, selectedValues }));
    });
  }
}

async function applyVehicleFilter() {
  if (applying) {
    rerunRequested = true;
    return;
  }

  applying = true;
  rerunRequested = false;

  const filters = selectedFilters();
  const resultsList = document.querySelector('results-list');
  const cards = Array.from(document.querySelectorAll(CARD_SELECTOR));

  try {
    syncCustomFilterControls();
    await updateDynamicVehicleFilterOptions(filters, cards);

    if (!hasVehicleSelection(filters)) {
      for (const card of cards) setVisible(card, productMatchesGroup(card, filters.productGroups));
      setStatus('');
      document.documentElement.classList.remove('wx-vehicle-filter-pending');
      resultsList?.classList.remove('wx-vehicle-filtering');
      return;
    }

    resultsList?.classList.add('wx-vehicle-filtering');
    setStatus(`Vérification des compatibilités : ${selectionLabel(filters) || 'véhicule sélectionné'}…`, 'loading');

    const resolvedKtypes = await resolveKtypes(filters);
    let compatibleProducts = null;

    if (resolvedKtypes.size) {
      compatibleProducts = await compatibleProductsForKtypes(resolvedKtypes);
    }

    let visibleCount = 0;
    const hasVerifiedCompatibleProducts =
      compatibleProducts &&
      (compatibleProducts.productIds.size > 0 || compatibleProducts.handles.size > 0);

    let currentScopeHasProducts = null;

    if (resolvedKtypes.size > 0 && compatibleProducts) {
      currentScopeHasProducts = hasVerifiedCompatibleProducts
        ? await currentScopeCompatibilityState(compatibleProducts)
        : false;
    }

    const definitiveNoCompatibleProduct =
      resolvedKtypes.size > 0 &&
      compatibleProducts &&
      currentScopeHasProducts === false;

    if (hasVerifiedCompatibleProducts) {
      for (const card of cards) {
        const cardProductId = normalizeShopifyProductId(card.dataset.wxProductId);
        const cardHandle = String(card.dataset.wxProductHandle || '').trim();
        const matchesVehicle =
          (cardProductId && compatibleProducts.productIds.has(cardProductId)) ||
          (cardHandle && compatibleProducts.handles.has(cardHandle));
        const visible = productMatchesGroup(card, filters.productGroups) && matchesVehicle;
        setVisible(card, visible);
        if (visible) visibleCount += 1;
      }
    } else {
      const matches = await Promise.all(cards.map((card) => fallbackCardMatch(card, filters)));
      matches.forEach((visible, index) => {
        setVisible(cards[index], visible);
        if (visible) visibleCount += 1;
      });
    }

    const selected = vehicleDisplayLabel() || selectionLabel(filters) || 'véhicule sélectionné';

    if (definitiveNoCompatibleProduct) {
      setStatus(
        `${selected} : aucune pièce compatible vérifiée dans notre catalogue.`,
        'selection',
      );
      openEmptyVehicleModal(filters, resolvedKtypes);
    } else {
      setStatus(
        visibleCount
          ? `${selected} : ${visibleCount} produit${visibleCount > 1 ? 's' : ''} compatible${visibleCount > 1 ? 's' : ''} chargé${visibleCount > 1 ? 's' : ''}.`
          : `${selected} : aucun produit compatible dans les résultats actuellement chargés.`,
        'selection',
      );
    }
  } catch (error) {
    console.error('WIMEXIA vehicle filter', error);
    setStatus('Impossible de vérifier les compatibilités véhicule pour le moment.', 'error');
  } finally {
    document.documentElement.classList.remove('wx-vehicle-filter-pending');
    resultsList?.classList.remove('wx-vehicle-filtering');
    applying = false;

    if (rerunRequested) {
      rerunRequested = false;
      scheduleVehicleFilter();
    }
  }
}

function scheduleVehicleFilter() {
  if (scheduledFrame) return;

  scheduledFrame = window.requestAnimationFrame(() => {
    scheduledFrame = 0;
    void applyVehicleFilter();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  scheduleVehicleFilter();
  checkSearchEmptyState();
});
document.addEventListener('shopify:section:load', () => {
  scheduleVehicleFilter();
  checkSearchEmptyState();
});
document.addEventListener(
  'change',
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-wx-custom-filter-input]')) return;

    if (input.name === VEHICLE_MODEL_PARAM && input.checked) {
      const form = input.closest('form');
      for (const vehicleInput of form?.querySelectorAll(`input[name="${VEHICLE_TYPE_PARAM}"]`) || []) {
        if (vehicleInput instanceof HTMLInputElement) vehicleInput.checked = false;
      }
    }

    scheduleVehicleFilter();
  },
  true,
);

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches?.(CARD_SELECTOR) || node.querySelector?.(CARD_SELECTOR)) {
        scheduleVehicleFilter();
        return;
      }
    }
  }
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
